import { Divider, Typography } from '@mui/material';
import AttrLabel from './Components/AttrLabel';
import FormProviderWrapper from './Components/FormProviderWrapper';
import PanelSection from './Components/PanelSection';
import AttrField from './Fields/AttrField';
import ColorField from './Fields/ColorField';
import PaddingFields from './Fields/PaddingFields';
import PixelField from './Fields/PixelField';
import Headings from './Headings';
import BorderFields from './Fields/BorderFields';
import FormatButtons from './Fields/FormatButtons';
import { useTranslation } from 'react-i18next';
import { elements } from '@elements';
import InlineLabel from './Components/InlineLabel';
import FileField from './Fields/FileField';
import SelectField from './Fields/SelectField';

const htmlPath = [0];
const bodyPath = [0, 0];
const contentPath = [0, 0, 0]; // Container

// TODO: make sure all the paths are correct
function StylePanel() {
    const { t } = useTranslation();

    return (
        <FormProviderWrapper>
            <PanelSection label={t('Email Settings')}>
                <AttrLabel>{t('Email Language')}</AttrLabel>
                <AttrField
                    name="lang"
                    property="theme"
                    Component={SelectField}
                    // path={[]}
                    options={[
                        { value: 'en', label: 'English' },
                        { value: 'he', label: 'עברית' },
                    ]}
                />
                <AttrLabel>{t('Email Background')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="style.backgroundColor"
                    placeholder={t('Email Background')}
                    property="attributes"
                    path={bodyPath}
                    fallback={
                        elements.body.node.attributes.style.backgroundColor
                    }
                />
            </PanelSection>
            <PanelSection label={t('Content Settings')}>
                <AttrLabel>{t('Background Image')}</AttrLabel>
                <AttrField
                    name="style.backgroundImage"
                    Component={FileField}
                    sx={{ height: 100 }}
                    backgroundImage
                    path={contentPath}
                />
                <AttrLabel>{t('Background Color')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="style.backgroundColor"
                    placeholder={t('Background Color')}
                    path={contentPath}
                />
                <AttrLabel>{t('Width')}</AttrLabel>
                <AttrField
                    Component={PixelField}
                    name="style.maxWidth"
                    placeholder={t('Full Width')}
                    path={contentPath}
                />
                <AttrLabel>{t('Margin Top')}</AttrLabel>
                <AttrField
                    Component={PixelField}
                    name="style.paddingTop"
                    property="attributes"
                    placeholder="0"
                    path={bodyPath}
                />
                <AttrLabel>{t('Margin Bottom')}</AttrLabel>
                <AttrField
                    Component={PixelField}
                    name="style.paddingBottom"
                    property="attributes"
                    placeholder="0"
                    path={bodyPath}
                />
                <AttrLabel>{t('Rounded Corners')}</AttrLabel>
                <AttrField
                    Component={PixelField}
                    name="style.borderRadius"
                    placeholder="0"
                    path={contentPath}
                />
            </PanelSection>
            <PanelSection label={t('Text & Headings')}>
                <Headings />
            </PanelSection>
            <PanelSection label={t('Button')}>
                <AttrLabel>{t('Button Color')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="backgroundColor"
                    placeholder={t('Button Color')}
                    property="theme.button.style"
                />
                <AttrLabel>{t('Text Color')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="color"
                    placeholder={t('Text Color')}
                    property="theme.button.style"
                />
                <AttrLabel>{t('Padding')}</AttrLabel>
                <PaddingFields name="padding" property="theme.button.style" />
                <Divider sx={{ mt: 4, mx: -2 }} />
                <Typography
                    variant="body2"
                    fontWeight={500}
                    color="textSecondary"
                    my={1}
                    textTransform="uppercase"
                >
                    {t('Border Settings')}
                </Typography>
                {/* <Typography variant="button">Border</Typography> */}
                <BorderFields property="theme.button.style" nameCase="kebab" />
            </PanelSection>
            <PanelSection label={t('Links')}>
                <AttrLabel>{t('Link Color')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="color"
                    placeholder="#0000EE"
                    property="globalStyles.link"
                />
                <InlineLabel label={t('Link Format')}>
                    <FormatButtons
                        property="globalStyles.link"
                        nameCase="kebab"
                    />
                </InlineLabel>
            </PanelSection>
        </FormProviderWrapper>
    );
}

export default StylePanel;
